import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { IAPIDonarsGridModel } from "../interfaces";
import { ContactReferenceModel } from "./ContactDetailPageModel";

 
 
export class DonarsGridModel {
    totalAmount: number;
    totalNumber: number;
    lastAmount: number;
    lastDonatedOn: Date;
    isRecurring: boolean;
    contact?: ContactReferenceModel;
    constructor(data?: Partial<DonarsGridModel>) {
        this.totalAmount = data?.totalAmount || 0;
        this.totalNumber = data?.totalNumber || 0;
        this.lastAmount = data?.lastAmount || 0;
        this.lastDonatedOn = data?.lastDonatedOn || new Date();
        this.isRecurring = data?.isRecurring || false;
        this.contact = data?.contact && new ContactReferenceModel(data.contact);
    }

    static deserialize(data: IAPIDonarsGridModel): DonarsGridModel {
        return new DonarsGridModel({
            totalAmount: data.totalAmount,
            totalNumber: data.totalNumber,
            lastAmount: data.lastAmount,
            lastDonatedOn: UtilityMethods.removeZFromDateString(data.lastDonatedOn),
            isRecurring: data.isRecurring,
            contact: data.contact && ContactReferenceModel.deserializeAPIModel(data.contact),
        });
    }
}
